"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classnames2 = require("classnames");

var _classnames3 = _interopRequireDefault(_classnames2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BlankValue = require("./BlankValue");

var _BlankValue2 = _interopRequireDefault(_BlankValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InfoRow = function InfoRow(props) {
  var blankValue = props.blankValue,
      children = props.children,
      className = props.className,
      label = props.label,
      labelForFalse = props.labelForFalse,
      labelForTrue = props.labelForTrue,
      spaced = props.spaced;

  var rootClass = (0, _classnames3.default)("erg-components-InfoRow", "erg-info-row", className, _defineProperty({}, "erg-info-row-spaced-" + spaced, true));

  var value = void 0;
  if (typeof children === "boolean") {
    value = children ? labelForTrue : labelForFalse;
  } else {
    value = children || blankValue || _react2.default.createElement(_BlankValue2.default, null);
  }

  return _react2.default.createElement(
    "div",
    { className: rootClass },
    _react2.default.createElement(
      "label",
      { className: "erg-info-label" },
      label,
      ":"
    ),
    _react2.default.createElement(
      "label",
      { className: "erg-info-value" },
      value
    )
  );
};

InfoRow.displayName = "InfoRow";

InfoRow.defaultProps = {
  labelForFalse: "No",
  labelForTrue: "Yes"
};

InfoRow.propTypes = {
  blankValue: _propTypes2.default.node,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.bool]),
  className: _propTypes2.default.string,
  label: _propTypes2.default.string.isRequired,
  labelForFalse: _propTypes2.default.string,
  labelForTrue: _propTypes2.default.string,
  spaced: _propTypes2.default.oneOf(["md", "lg"])
};

exports.default = InfoRow;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/InfoRow.js
 ** module id = 785
 ** module chunks = 0
 **/